export default {"src":"/_next/static/media/NET.15eb74b2.svg","height":18,"width":18};